import styled from 'styled-components';

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100%;
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 13px;
  box-sizing: border-box;
  margin-top: 2rem;

`
export const FormRow = styled.div`

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 20px;
  box-sizing: border-box;
  align-items: flex-start;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 2rem;
  max-width:95%;
  width: 100%;
  margin: 0 auto;
`

export const HorizontalContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`
export const ButtonRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: calc(5px + 1vw);
`
export const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(40%, 1fr));
    grid-gap: 0.1rem;
    /* width: inherit; */
    max-width: -webkit-fill-available;
`
export const ViewSLAContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: inherit;
    max-width: -webkit-fill-available;
`

export const SmallBottomNegativeMargin = styled.div`
    margin-bottom: -0.5rem;
`

export const ActionButtonGroup = styled.span`
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 0.6rem;
    width: 100%;
    max-width: -webkit-fill-available;
`

// Add more styled components as needed
